import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getCargoTags(companyId) {
	return dataTransferWrap(
		ModulesMap.CARGO_TAGS,
		dtConfig[ModulesMap.CARGO_TAGS].getCargoTags,
		{
			urlParams: {
				companyId,
			},
		}
	)
}

function getCargoTag(companyId, cargoTagId) {
	return dataTransferWrap(
		ModulesMap.CARGO_TAGS,
		dtConfig[ModulesMap.CARGO_TAGS].getCargoTag,
		{
			urlParams: {
				companyId,
				cargoTagId,
			},
		}
	)
}

function createCargoTag(companyId, payload) {
	return dataTransferWrap(
		ModulesMap.CARGO_TAGS,
		dtConfig[ModulesMap.CARGO_TAGS].createCargoTag,
		{
			urlParams: {
				companyId,
			},
			...payload,
		}
	)
}


function putCargoTag(companyId, cargoTagId, payload) {
	return dataTransferWrap(
		ModulesMap.CARGO_TAGS,
		dtConfig[ModulesMap.CARGO_TAGS].putCargoTag,
		{
			urlParams: {
				companyId,
				cargoTagId,
			},
			...payload,
		}
	)
}

function patchCargoTag(companyId, cargoTagId, payload) {
	return dataTransferWrap(
		ModulesMap.CARGO_TAGS,
		dtConfig[ModulesMap.CARGO_TAGS].patchCargoTag,
		{
			urlParams: {
				companyId,
				cargoTagId,
			},
			...payload,
		}
	)
}

function deleteCargoTag(companyId, cargoTagId) {
	return dataTransferWrap(
		ModulesMap.CARGO_TAGS,
		dtConfig[ModulesMap.CARGO_TAGS].deleteCargoTag,
		{
			urlParams: {
				companyId,
				cargoTagId,
			},
		}
	)
}

export default {
	getCargoTags,
	getCargoTag,
	createCargoTag,
	putCargoTag,
	patchCargoTag,
	deleteCargoTag,
}

